var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyCountry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25C9.51472 2.25 7.5 4.26472 7.5 6.75C7.5 9.23528 9.51472 11.25 12 11.25C14.4853 11.25 16.5 9.23528 16.5 6.75C16.5 4.26472 14.4853 2.25 12 2.25Z",
    fill: "#171717",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 11.75C4.01472 11.75 2 13.7647 2 16.25C2 18.7353 4.01472 20.75 6.5 20.75C8.98528 20.75 11 18.7353 11 16.25C11 13.7647 8.98528 11.75 6.5 11.75Z",
    fill: "#171717",
    fillOpacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11.75C15.0147 11.75 13 13.7647 13 16.25C13 18.7353 15.0147 20.75 17.5 20.75C19.9853 20.75 22 18.7353 22 16.25C22 13.7647 19.9853 11.75 17.5 11.75Z",
    fill: "#171717",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCountry);
export default __webpack_public_path__ + "static/media/empty-country.ca4d4160e7ec0ca7e031e11f8d719346.svg";
export { ForwardRef as ReactComponent };